import React, { useMemo } from "react";
import {
  useAddRelationTypeMutation,
  useDeleteRelationTypeMutation,
  useGetRelationTypesQuery,
  useUpdateRelationTypeMutation,
} from "../../features/relationTypes/relationTypeApi";
import { useLazyPlantOptions } from "../../features/plants/usePlantOptions";
import MasterCrudPage from "../masters/MasterCrudPage";
import { withAuditFilters } from "../masters/filterMetadata";
import { getPlantLabel, renderPlantCell } from "../masters/masterMetadata";

const relationTypeFilterFields = withAuditFilters([
  { name: "relation_id", label: "Relation ID", optionSource: "relationTypes" },
  { name: "relation_type", label: "Relation Type" },
]);

const RelationType = () => {
  const {
    options: plantOptions,
    isFetching: isLoadingPlants,
    loadOptions: loadPlantOptions,
  } = useLazyPlantOptions();

  const fields = useMemo(
    () => [
      {
        name: "plant_id",
        label: "Plant",
        type: "select",
        options: plantOptions,
        placeholder: isLoadingPlants ? "Loading plants..." : "Select plant",
        disabled: isLoadingPlants && plantOptions.length === 0,
        disabledOnEdit: true,
        required: true,
        fullWidth: true,
      },
      {
        name: "relation_type",
        label: "Relation Type",
        placeholder: "Enter relation type",
        required: true,
        fullWidth: true,
      },
    ],
    [isLoadingPlants, plantOptions]
  );

  const columns = useMemo(
    () => (metaData) => [
      {
        name: "Relation ID",
        selector: (row) => row?.relation_id || "-",
        sortable: true,
      },
      {
        name: "Relation Type",
        selector: (row) => row?.relation_type || "-",
        sortable: true,
        grow: 2,
      },
      {
        name: "Plant",
        selector: (row) => getPlantLabel(row, metaData),
        cell: (row) => renderPlantCell(row, metaData),
        sortable: true,
        grow: 2,
      },
    ],
    []
  );

  return (
    <MasterCrudPage
      entityName="Relation Type"
      pageTitle="Relation Types"
      idField="relation_id"
      displayField="relation_type"
      fields={fields}
      columns={columns}
      searchFields={[
        "relation_id",
        "relation_type",
        "plant_id",
        (row, metaData) => getPlantLabel(row, metaData),
      ]}
      searchPlaceholder="Search relation types"
      useListQuery={useGetRelationTypesQuery}
      useCreateMutation={useAddRelationTypeMutation}
      useUpdateMutation={useUpdateRelationTypeMutation}
      useDeleteMutation={useDeleteRelationTypeMutation}
      filterFields={relationTypeFilterFields}
      showQrColumn={false}
      transformPayload={(payload, editData) => {
        if (!editData) return payload;
        const updatePayload = { ...payload };
        delete updatePayload.plant_id;
        return updatePayload;
      }}
      onOpenForm={loadPlantOptions}
      noDataLabel="No relation types found"
    />
  );
};

export default RelationType;
